import {FC, useMemo} from "react";
import {createRouter} from "./Main";
import {RouterProvider} from "react-router-dom";
import {LicenseInfo} from "@mui/x-license";
import {withDevCycleProvider} from "@devcycle/react-client-sdk";
import {defaultTheme as createDefaultTheme} from "./templates/defaultTheme";
import {ThemeProvider} from "@mui/material";
import SnackbarProviderWrapper from "./snackbars/SnackbarProviderWrapper";
import {StoreUpdateAvailableModalHost} from "@/app2/components/StoreUpdateAvailableModal";

const MUI_LICENSE = process.env.REACT_APP_MUI_LICENSE
const DEVCYCLE_LICENSE = process.env.REACT_APP_DEVCYCLE_KEY ?? "";
if (!MUI_LICENSE)
	throw new Error("Failed to get REACT_APP_MUI_LICENSE env")

LicenseInfo.setLicenseKey(MUI_LICENSE);

const App: FC = () => {
	const defaultTheme = useMemo(() => createDefaultTheme(), []);
	const router = useMemo(() => createRouter(), []);

	return (
		<ThemeProvider theme={defaultTheme}>
			<SnackbarProviderWrapper>
				<RouterProvider router={router} />
				<StoreUpdateAvailableModalHost />
			</SnackbarProviderWrapper>
		</ThemeProvider>
	)
};

export default withDevCycleProvider({
	sdkKey: DEVCYCLE_LICENSE,
	options: {
		deferInitialization: true
	}
})(App);